import { useState } from 'react';
import { FiEye, FiEyeOff, FiCopy, FiCheck } from 'react-icons/fi';
import { toast } from 'react-toastify';

interface ConsultationPasswordFieldProps {
    password: string | null | undefined;
}

// Senha de consulta processual no Resumo do caso (Task 13). Oculta por padrão — o jurídico
// clica para revelar e/ou copiar (cola no portal do tribunal). Nunca aparece no page-list;
// esta exibição vive só no detalhe. A senha vem do page-view; não é digitada aqui (o cadastro
// é no form do caso).
const ConsultationPasswordField = ({ password }: ConsultationPasswordFieldProps) => {
    const [revealed, setRevealed] = useState(false);
    const [copied, setCopied] = useState(false);

    if (!password) return null;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(password);
            setCopied(true);
            toast.success('Senha copiada');
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error('Não foi possível copiar a senha');
        }
    };

    return (
        <div className="border-t border-gray-200 dark:border-slate-700 pt-3 space-y-2">
            <h4 className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase">
                Senha de consulta processual
            </h4>
            <div className="flex items-center gap-2">
                <span className="text-sm font-mono dark:text-white select-all">
                    {revealed ? password : '••••••••'}
                </span>
                <button
                    onClick={() => setRevealed((v) => !v)}
                    title={revealed ? 'Ocultar' : 'Mostrar'}
                    className="p-1.5 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg"
                >
                    {revealed ? <FiEyeOff size={14} /> : <FiEye size={14} />}
                </button>
                <button
                    onClick={copy}
                    title="Copiar senha"
                    className="p-1.5 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900 rounded-lg"
                >
                    {copied ? <FiCheck size={14} /> : <FiCopy size={14} />}
                </button>
            </div>
        </div>
    );
};

export default ConsultationPasswordField;
